// core version + navigation, pagination modules:
// import Swiper, { Navigation, Pagination } from "swiper";
import Swiper from "swiper/bundle";
import rPlayer from '../rplayer.js';

// configure Swiper to use modules
// Swiper.use([Navigation, Pagination]);
//import Slider from "../slider";
//import "selectric";
//import "jquery-match-height";
//import "jquery-datetimepicker";
//import { TweenMax } from "gsap";
//import { scrollAnimation, setUpCharacters } from "../scrolling";
var isDevice = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
  navigator.userAgent.toLowerCase()
);



var isMobile = /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i.test(
  navigator.userAgent.toLowerCase()
);

let ajax_url = $("#load-more-show .load-more").data("ajax");


    $(document).ready(function(){

      // Add loader to player until window loaded

      var windowLoadingSpinner = "<i class=\"fa fa-spinner fa-spin\"></i>";

      $('.c-header span[class*="listen-"]').each(function(){
        $(this).html(windowLoadingSpinner);
      });

    });



    function moreInfo() {
    $("#more-info").on("click", function (e) {
      e.preventDefault();
      // console.log('more info clicked');
    // var tl = 400;
    $(".c-header__sup").toggleClass("c-header__sup--more-info");
    $(".c-header__main").toggleClass("c-header__main--more-info");

    if ($(".c-header__sup").hasClass("c-header__sup--more-info")) {
      $(".c-more-info").slideDown();
      $(".c-header__sup.c-header__sup--more-info").animate(
        {
          top: 335,
        },
        // tl
      );
      $(".c-header__main.c-header__main--more-info").animate(
        {
          top: 375,
        },
        // tl
      );
      $(".c-home").animate(
        {
          marginTop: "335px",
        },
        // tl
      );
    } else {
      $(".c-more-info").slideUp("fast");
      $(".c-header__main").animate({ top: 40 });
      $(".c-header__sup").animate({ top: 0 });
      $(".c-home").animate({ marginTop: 0 });
    }
  });
  }

  moreInfo();



    $(".widget-pause-button").on("click", function () {
      alert('pause')
    });


    $(".listen-header").on("click", function () {
      $(this).toggleClass("play");
      if ($(".listen-header").hasClass("play")) {
        $(this).html("PAUSE");
      } else {
        $(this).html("LISTEN");
      }
    });

    if ($(window).width() < 768) {
      $(window).scroll(function() {
        if($(window).scrollTop() >= 49){
          $('.c-header__listen').addClass('c-header__listen-fixed');
        } else if($(window).scrollTop() < 49) {
          $('.c-header__listen').removeClass('c-header__listen-fixed');
        }
      });
    }

    function swiper() {

      var swiper = new Swiper("#ballantines-posts .news-slider .swiper-container", {
        slidesPerView: 1,
        spaceBetween: 30,
        pagination: {
          el: ".news-slider .swiper-pagination",
        },
        loop: false,
        loopFillGroupWithBlank: true,
        navigation: {
          nextEl: ".news-slider .swiper-button-next",
          prevEl: ".news-slider .swiper-button-prev",
        },
        breakpoints: {
          // when window width is >= 320px
          768: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          1280: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
        },
      });

      var swiper = new Swiper("#ballantines-posts .vinyl-sessions-slider .swiper-container", {
        slidesPerView: 1,
        spaceBetween: 30,
        pagination: {
          el: ".vinyl-sessions-slider .swiper-pagination",
        },
        loop: false,
        loopFillGroupWithBlank: false,
        navigation: {
          nextEl: ".vinyl-sessions-slider .swiper-button-next",
          prevEl: ".vinyl-sessions-slider .swiper-button-prev",
        },
        breakpoints: {
          // when window width is >= 320px
          768: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          1280: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
        },
      });

    var swiper = new Swiper(".c-home--main__banner .swiper-container", {
      loop: true,
      disableOnInteraction: true,
      speed: 1000,
      autoplay: {
        delay: 6000,
      },
      navigation: {
        nextEl:
          ".c-home--main__banner .c-home--main__arrow-slide .o-btn--arrow.next",
        prevEl:
          ".c-home--main__banner .c-home--main__arrow-slide .o-btn--arrow.prev",
      },
      // on: {
      //   slideChange: function () {
      //     $(".c-home--main__img img").css({
      //       width: "100%",
      //       height: "100%",
      //     });
      //     setTimeout(function () {
      //       $(".swiper-slide-active .c-home--main__img img").animate(
      //         {
      //           width: "+=100",
      //           height: "+=100",
      //         },
      //         3000
      //       );
      //     }, 1500);
      //   },
      // },
    });

    var swiper = new Swiper(".trending-show-session .swiper-container", {
      slidesPerView: 1,
      spaceBetween: 30,
      pagination: {
        el: ".swiper-pagination",
      },
      loop: true,
      loopFillGroupWithBlank: true,
      navigation: {
        nextEl: ".trending-show-session--arrow .swiper-button-next",
        prevEl: ".trending-show-session--arrow .swiper-button-prev",
      },
      breakpoints: {
        // when window width is >= 320px
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },
    });

    var swiper = new Swiper(".vinyl-session .swiper-container", {
      slidesPerView: 1,
      spaceBetween: 20,
      // pagination: " ",
      loop: true,
      navigation: {
        nextEl: ".vinyl-session--arrow .swiper-button-next",
        prevEl: ".vinyl-session--arrow .swiper-button-prev",
      },
      breakpoints: {
        // when window width is >= 320px
        768: {
          slidesPerView: 2,
          spaceBetween: 30,
          pagination: {
            el: ".swiper-pagination",
          },
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 30,
          pagination: {
            el: ".swiper-pagination",
          },
        },
        1600: {
          slidesPerView: 4,
          spaceBetween: 30,
          pagination: {
            el: ".swiper-pagination",
          },
        },
      },
    });
    var swiper = new Swiper(".vinyl-session--home .swiper-container", {
      slidesPerView: 1,
      spaceBetween: 20,
      // pagination: " ",
      loop: true,
      navigation: {
        nextEl: ".vinyl-session--arrow .swiper-button-next",
        prevEl: ".vinyl-session--arrow .swiper-button-prev",
      },
      breakpoints: {
        // when window width is >= 320px
        768: {
          slidesPerView: 2,
          spaceBetween: 30,
          pagination: {
            el: ".swiper-pagination",
          },
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 30,
          pagination: {
            el: ".swiper-pagination",
          },
        },
      },
    });

    var swiper = new Swiper(".trending-show-footer .swiper-container", {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      navigation: {
        nextEl: ".trending-show-footer--arrow .swiper-button-next",
        prevEl: ".trending-show-footer--arrow .swiper-button-prev",
      },
      breakpoints: {
        // when window width is >= 320px
        768: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
        // 1600: {
        //   slidesPerView: 5,
        //   spaceBetween: 30,
        // },
      },
    });

    var swiper = new Swiper(".more-from-session .swiper-container", {
      slidesPerView: 1,
      spaceBetween: 10,
      pagination: {
        el: ".swiper-pagination",
      },
      loop: true,
      navigation: {
        nextEl: ".more-from-session--arrow .swiper-button-next",
        prevEl: ".more-from-session--arrow .swiper-button-prev",
      },
      breakpoints: {
        // when window width is >= 320px
        768: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
        1600: {
          slidesPerView: 4,
          spaceBetween: 30,
          loop: false,
        },
      },
    });

    var swiper = new Swiper(".might-like .swiper-container", {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: true,
      pagination: {
        el: ".swiper-pagination",
      },
      navigation: {
        nextEl: ".might-like-session--arrow .swiper-button-next",
        prevEl: ".might-like-session--arrow .swiper-button-prev",
      },
      breakpoints: {
        // when window width is >= 320px
        768: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
        1600: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },
    });

    var swiper = new Swiper(".in-the-news .swiper-container", {
      slidesPerView: 1,
      spaceBetween: 20,
      pagination: {
        el: ".swiper-pagination",
      },
      loop: true,
      navigation: {
        nextEl: ".in-the-news-session--arrow .swiper-button-next",
        prevEl: ".in-the-news-session--arrow .swiper-button-prev",
      },
      breakpoints: {
        // when window width is >= 320px
        768: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },
    });
    var swiper = new Swiper(".in-the-news--home .swiper-container", {
      slidesPerView: 1,
      spaceBetween: 20,
      pagination: {
        el: ".swiper-pagination",
      },
      loop: true,
      navigation: {
        nextEl: ".in-the-news-session--arrow .swiper-button-next",
        prevEl: ".in-the-news-session--arrow .swiper-button-prev",
      },
      breakpoints: {
        // when window width is >= 320px
        768: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },
    });

    }

    $(document).ready(function() {
    swiper();
    });

    // $(".c-card, .c-card--home")
    //   .on("mouseenter", function () {
    //     if ($(window).width() < 1280) {
    //       $(this).find(".c-card__img .c-overlay").animate(
    //         {
    //           top: 0,
    //           opacity: 1,
    //           height: 450,
    //         },
    //         400
    //       );
    //     }
    //     else {
    //       $(this).find(".c-card__img .c-overlay").animate(
    //         {
    //           top: 0,
    //           opacity: 1,
    //           height: 280,
    //         },
    //         400
    //       );
    //     }
    //   })
    //   .on("mouseleave", function () {
    //     $(this).find(".c-card__img .c-overlay").animate({
    //       opacity: 0,
    //       top: 230,
    //       height: 0,
    //     });
    //   });

    function menuTab() {
    $(".menu-tab .hamburger").on("click", function () {

      if($(this).hasClass('is-active')) {

        $('html').removeClass('has-popup');

        $(this).removeClass('is-active');
        $(".menu-tab__slide--menu").animate(
          {
            opacity: 0,
            right: -350,
          },
          400,
          function () {
            $(".menu-tab__overlay-slide").hide();
            $(".menu-tab__slide--menu").hide();
          }
        );

      } else {

        $(this).addClass('is-active');

        $('html').addClass('has-popup');

        $(".menu-tab__slide--menu").show();
        $(".menu-tab__slide--menu").animate(
          {
            opacity: 1,
            right: -2,
          },
          400,
          function () {
            $(".menu-tab__overlay-slide").show();
          }
        );
      }
    });
    }

    menuTab();

    function latestShows() {

    $(".menu-lastest").on("click", function () {
      $(".menu-tab__slide--lastest").show();
      $(".menu-tab__slide--lastest").animate(
        {
          opacity: 1,
          left: 0,
        },
        400,
        function () {
          $(".menu-tab__overlay-slide").show();
          $('html').addClass('has-popup');
        }
      );
    });


    $(".menu-listen a").on("click", function (e) {
      e.preventDefault();
      $(".menu-tab__slide--listen").show();
      $(".menu-tab__slide--listen").animate(
        {
          opacity: 1,
          right: 0,
        },
        400,
        function () {
          $(".menu-tab__overlay-slide").show();
          $('html').addClass('has-popup');
        }
      );
    });

    $(".menu-tab__slide--lastest .menu-tab__icon").on("click", function () {
      $(".menu-tab__slide--lastest").animate(
        {
          opacity: 0,
          left: -350,
        },
        400,
        function () {
          $(".menu-tab__overlay-slide").hide();
          $(".menu-tab__slide--lastest").hide();
          $('html').removeClass('has-popup');
        }
      );
    });

    $(".menu-tab__slide--listen .menu-tab__icon").on("click", function () {
      $(".menu-tab__slide--listen").animate(
        {
          opacity: 0,
          right: -350,
        },
        400,
        function () {
          $(".menu-tab__overlay-slide").hide();
          $(".menu-tab__slide--listen").hide();
          $(".menu-tab__slide--lastest").hide();
          $('html').removeClass('has-popup');
        }
      );
    });

  }

    latestShows();


    function loadMore() {
    // Shows
    $("#load-more-show .load-more-btn").on("click", function (e) {
      e.preventDefault();
      $("#load-more-show .load-more-btn").html("LOADING...");
      let page = $("#load-more-show .load-more-btn").data("page");
      let type = $("#load-more-show .load-more-btn").data("type");
      let ajax_url = $("#load-more-show .load-more").data("ajax");

      let data = { action: "ajaxItem_load_more", page: page, type: type };
      $.post(ajax_url, data, function (response) {
        let res = response;
        page += 1;
        $("#load-more-show .load-more-btn").data("page", page).data();
        let listItem = res.list_item;

        listItem.forEach(function (item) {
          let time = item.post_date;
          $("#load-more-show .load-more").append(
            '<div class="u-1/4@desktop u-1/2@tablet u-1/1 u-p-xs u-mb-m"><a href="' +
              item.link +
              '" class="c-card"><div class="c-card__img"><picture><img src="' +
              item.image +
              '" alt="' +
              item.title +
              '" class="lazyload o-img o-img--list-item"></picture>' +
              '<div class="c-overlay"></div></div><div class="c-card__text  u-bg-light-gray"><div class="c-card__inner"><h2 class="c-card__title">' +
              item.title +
              "</h2><div>" +
              item.content +
              '</div></div><div class="o-link o-link__viking-blue">See all episodes</div></div></a></div>'
          );
        });
        $("#load-more-show .load-more-btn").html("LOAD MORE");
      });
    });
    // Blog
    $("#load-more-blog .load-more-btn").on("click", function (e) {
      e.preventDefault();
      $("#load-more-blog .load-more-btn").html("LOADING...");
      let page = $("#load-more-blog .load-more-btn").data("page");
      let type = $("#load-more-blog .load-more-btn").data("type");
      let category = $("#load-more-blog .load-more-btn").data("category");
      let ajax_url = $("#load-more-blog .load-more").data("ajax");
      let data = {
        action: "ajaxItem_load_more",
        page: page,
        type: type,
        category: category,
      };

      $.post(ajax_url, data, function (listofposts) {
        // console.log('response', listofposts);
        if(listofposts) {
          let res = listofposts;
          page += 1;
          $("#load-more-blog .load-more-btn").data("page", page).data();
          let listItem = res.list_item;

          listItem.forEach(function (item) {
            let time = item.post_date;
            $("#load-more-blog .load-more").append(
              '<div class="u-1/4@desktop u-1/2@tablet u-1/1 u-mb-m box-card"><a href="' +
                item.link +
                '" class="c-card"><div class="c-card__img"><picture><img src="' +
                item.image +
                '" alt="' +
                item.title +
                '" class="lazyload o-img o-img--list-item"></picture>' +
                '<div class="c-overlay"></div></div><div class="c-card__text  u-bg-light-gray"><div class="c-card__inner"><h2 class="c-card__title">' +
                item.title +
                '</h2><div>' +
                item.content +
                '</div></div><div class="o-link o-link__viking-blue">Read More</div></div></a></div>'
            );
          });
          $("#load-more-blog .load-more-btn").html("LOAD MORE");
        } else {
          $("#load-more-blog .load-more-btn").fadeOut();
        }
      });
    });
    // Vinyl sessions
    $("#load-more-vinyl-sessions .load-more-btn").on("click", function (e) {
      e.preventDefault();
      $("#load-more-vinyl-sessions .load-more-btn").html("LOADING...");
      let page = $("#load-more-vinyl-sessions .load-more-btn").data("page");
      let type = $("#load-more-vinyl-sessions .load-more-btn").data("type");
      let category = $("#load-more-vinyl-sessions .load-more-btn").data(
        "category"
      );
      let ajax_url = $("#load-more-vinyl-sessions .load-more").data("ajax");
      let data = {
        action: "ajaxItem_load_more",
        page: page,
        type: type,
        category: category,
      };

      $.post(ajax_url, data, function (response) {
        let res = response;

        // console.log(res);
        page += 1;

        $("#load-more-vinyl-sessions .load-more-btn").data("page", page).data();
        let listItem = res.list_item;

        listItem.forEach(function (item) {
          let time = item.post_date;
          $("#load-more-vinyl-sessions .load-more").append(
            '<div class="u-1/4@desktop u-1/2@tablet u-1/1 u-p-xs u-mb-m"><a href="' +
              item.link +
              '" class="c-card"><div class="c-card__img"><picture><img src="' +
              item.image +
              '" alt="' +
              item.title +
              '" class="lazyload o-img o-img--list-item"></picture>' +
              '<div class="c-overlay"></div></div><div class="c-card__text  u-bg-light-gray"><div class="c-card__inner"><h2 class="c-card__title">' +
              item.title +
              "</h2><div>" +
              item.content +
              '</div></div><div class="o-link o-link__viking-blue">Watch</div></div></a></div>'
          );
        });
        $("#load-more-vinyl-sessions .load-more-btn").html("LOAD MORE");
      });
    });
    // Filter buttons on shows
    $("#load-more-show .filter-button").on("click", function (e) {
      e.preventDefault();

      $("#load-more-show .o-btn--filter").removeClass("o-btn--active");
      $(this).addClass("o-btn--active");

      $(".load-more--section").hide();
      $("#load-more-show .show-on-filter").html("");

      let filter = $(this).data("filter");
      let category = $(this).data("category");
      let type = $(this).data("type");
      let ajax_url = $("#load-more-show .show-on-filter").data("ajax");
      let data = {
        action: "ajaxItem_load_more",
        category: category,
        type: type,
        filter: filter,
      };
      $.post(ajax_url, data, function (response) {
        let res = response;
        let listItem = res.list_item;

        listItem.forEach(function (item) {
          let time = item.post_date;
          $("#load-more-show .show-on-filter").append(
            '<div class="u-1/4@desktop u-1/2@tablet u-1/1 u-p-xs u-mb-m"><a href="' +
              item.link +
              '" class="c-card"><div class="c-card__img"><picture><img src="' +
              item.image +
              '" alt="' +
              item.title +
              '" class="lazyload o-img o-img--list-item"></picture>' +
              '<div class="c-overlay"></div></div><div class="c-card__text  u-bg-light-gray"><div class="c-card__inner"><h2 class="c-card__title">' +
              item.title +
              "</h2><div>" +
              item.content +
              '</div></div><div class="o-link o-link__viking-blue">See all episodes</div></div></a></div>'
          );
        });
      });
    });
    // search form on shows
    $(".c-form--show .c-form--search__submit").on("click", function () {
      $(".load-more--section").hide();
      $("#load-more-show .show-on-filter").html("");

      let ajax_url = $("#load-more-show .show-on-filter").data("ajax");
      let activeBtn = $("#load-more-show .filter-button.o-btn--active");

      let search = $("#search").val();
      let filter = activeBtn.data("filter");
      let category = activeBtn.data("category");
      let type = "podcastshow";

      let data = {
        action: "ajaxItem_load_more",
        category: category,
        type: type,
        filter: filter,
        search: search,
      };

      $.post(ajax_url, data, function (response) {
        let res = response;
        let listItem = res.list_item.filter((i) =>
          i.title.toLowerCase().includes(search.toLowerCase())
        );

        listItem.forEach(function (item) {
          let time = item.post_date;
          $("#load-more-show .show-on-filter").append(
            '<div class="u-1/4@desktop u-1/2@tablet u-1/1 u-p-xs u-mb-m"><a href="' +
              item.link +
              '" class="c-card"><div class="c-card__img"><picture><img src="' +
              item.image +
              '" alt="' +
              item.title +
              '" class="lazyload o-img o-img--list-item"></picture>' +
              '<div class="c-overlay"></div></div><div class="c-card__text  u-bg-light-gray"><div class="c-card__inner"><h2 class="c-card__title">' +
              item.title +
              "</h2><div>" +
              item.content +
              '</div></div><div class="o-link o-link__viking-blue">See all episodes</div></div></a></div>'
          );
        });
      });
    });

  }

  loadMore();

function getMusicCurrentLiveAPI() {
  const proxyurl = "https://cors-anywhere.herokuapp.com/";

  return jQuery.getJSON(
    "https://sohoradiomusic.doughunt.co.uk/api/live-info?callback=?",
    function (json) {
      var tabs = [];
      var key = "AIRTIME_API_VERSION";
      var index = 0;

      delete json[key];
    }
  );
}
function getLatestMusicName() {
  jQuery(function () {
    var liveUpdate = $("#music-live-update");
    var live = getMusicCurrentLiveAPI();

    function returnLive() {
      live = getMusicCurrentLiveAPI();

      live.done(function (json) {
        var current = json["currentShow"][0];
        var name = current["name"];
        var image = current["image_path"];
        var $image = $(
          '<img src="' +
            image +
            '" alt="" class="c-live__img c-live__img--fixed">'
        );

        if ($(".update-current-music-image").length !== 0) {
          $(".update-current-music-image").html($image);
        }

        name = name.replace("Soho Radio Music - ", "");
        name = name.replace("Soho Radio Culture - ", "");
        name = name.replace("- ", "");
        name = name.replace("&#039;", "'");

        if ($(".update-current-music-show").length !== 0) {
          $(".update-current-music-show").text(name);
        }

        liveUpdate.text(name);
        $('.header-player').removeClass('loading-live-text');
      });

      setTimeout(function () {
        returnLive();
      }, 60000);
    }

    returnLive();
  });
}

// function  getCultureCurrentLiveAPI() {
//   //const proxyurl = "https://cors-anywhere.herokuapp.com/";
//
//   return jQuery.getJSON(
//     "https://sohoradioculture.doughunt.co.uk/api/live-info?callback=?",
//     function (json) {
//       var tabs = [];
//       var key = "AIRTIME_API_VERSION";
//       var index = 0;
//
//       delete json[key];
//     }
//   );
// }
function getLatestCultureName() {
  jQuery(function () {
    var liveUpdate = $("#culture-live-update");
    var live = getCultureCurrentLiveAPI();

    function returnLive() {
      live = getCultureCurrentLiveAPI();

      live.done(function (json) {
        var current = json["currentShow"][0];
        var name = current["name"];
        var image = current["image_path"];
        var $image = $(
          '<img src="' +
            image +
            '" alt="" class="c-live__img c-live__img--fixed">'
        );

        if ($(".update-current-culture-image").length !== 0) {
          $(".update-current-culture-image").html($image);
        }

        name = name.replace("Soho Radio Music - ", "");
        name = name.replace("Soho Radio Culture - ", "");
        name = name.replace("- ", "");
        name = name.replace("&#039;", "'");

        if ($(".update-current-culture-show").length !== 0) {
          $(".update-current-culture-show").text(name);
        }

        liveUpdate.text(name);
      });

      setTimeout(function () {
        returnLive();
      }, 60000);
    }

    returnLive();
  });
}


getMusicCurrentLiveAPI();
// getCultureCurrentLiveAPI();
getLatestMusicName();
// getLatestCultureName();



var timerStart = Date.now();

$(document).ready(function(){

$('body div > iframe').on('load', function(){

$('body').addClass('radio-ready');

// radioPlayer();

// Remove window loading spinner from player

$('.c-header span[class*="listen-"]').each(function(){
  $(this).html('LISTEN');
});

});


});


$('.c-card.podcast').click(function(e){
  e.preventDefault();

  var episodeLink = $(this).attr('href');

  window.top.location.href = episodeLink;
});


$(window).on('load', function(){

  var isMobile = /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i.test(
    navigator.userAgent.toLowerCase()
  );

  // console.log('page loaded');

  if(isMobile) {
    $('body').addClass('mobile');
  } else {
    $('body').removeClass('mobile');
  }

  if($('.c-header span.listen-music').html() === 'PAUSE') {
    // console.log('listen music playing')
    setTimeout(function() {
    $('body').addClass('r-playing');
  }, 800);
  } else {
    $('body').removeClass('r-playing');
  }

  if($('.c-header span.listen-culture').html() === 'PAUSE') {
    setTimeout(function() {
    $('body').addClass('r-playing');
  }, 800);
  } else {
    $('body').removeClass('r-playing');
  }

  if(! $('body').hasClass('radio-ready')) {

    // radioPlayer();

    // Remove window loading spinner from player

    $('.c-header span[class*="listen-"]').each(function(){
      $(this).html('LISTEN');
    });

  }

});

function playerButtonText() {


  player = new rPlayer();

  var buttonStatus = $('.listen-music').html();

  if (buttonStatus == 'PAUSE') {
    // console.log('playing');
    $('.listen-music-container').addClass('r-play');
    $('.listen-music').click(function(e){
      e.stopPropagation();
      player.stop();
      // console.log('listen music clicked');
    });
  } else {
    // console.log('not playing');
  }
}

function disableBarba() {
  // document.querySelectorAll('a[href*="/contact/"]').forEach(item=>item.setAttribute('data-barba-prevent','self'));
  // $('.disable-barba').attr('data-barba-prevent', 'self');
}

disableBarba();

(function($) {

// If popup close button is clicked, set local storage
$('.popup-banner .close-btn').on('click', function(){
  localStorage.setItem('banner', 'closed');
  $('.popup-banner').removeClass('show');
});

if(localStorage.getItem('banner') == null) {
  setTimeout(function() {
    $('.popup-banner').addClass('show');
  }, 1500);
}

// Initialise Barba page navigation

var pageLoader = $('.page-loader');

barba.init({
  debug: true,
  timeout: 10000,
  transitions: [{
    name: 'default-transition',
    leave(data, current) {
      const done = this.async();
      setTimeout(function () {
        done();
      }, 800);
      $(pageLoader).fadeIn();
    },
    enter(data) {
      setTimeout(function() {
      $(pageLoader).fadeOut();
      }, 1000);
    }
  }]
});


// On enter
barba.hooks.enter((data, next) => {

  disableBarba();
  // getMusicCurrentLiveAPI();
  // getCultureCurrentLiveAPI();
  // getLatestMusicName();
  // getLatestCultureName();
  swiper();
  loadMore();
  latestShows();
  menuTab();
  // If pressing back/forward buttons, don't scroll to top

      if ('scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
      }



      // scroll page to top

      $(window).scrollTop(0);


});

})(jQuery);
